import { getMajorVersion } from '@repo/utils';
import useTaxaOverTime, {
  TaxaOverTime,
} from 'services/insights/useTaxaOverTime';
import useKitSystemInfo from 'services/system-info/useKitSystemInfo';
import { usePreviousKitMajorVersion } from 'services/system-info/usePreviousKitMajorVersion';

type Props = {
  metricId?: number;
};

export default function useGetTaxaOverTime({ metricId }: Props): TaxaOverTime {
  const { currentKit } = useKitSystemInfo();
  const { hasMultipleVersions } = usePreviousKitMajorVersion();
  const { data } = useTaxaOverTime({
    kitId: currentKit?.id,
    metricId,
  });

  if (!hasMultipleVersions) return data;

  const currentPoint = data.find(point => point?.kit_id === currentKit?.id);
  const currentKitMajorVersion = getMajorVersion(currentPoint?.version ?? '');

  return data.filter(
    point => getMajorVersion(point?.version ?? '') === currentKitMajorVersion,
  );
}
